import React from "react";
import { ChevronLeft, ChevronRight, Settings } from "lucide-react";

const Footer = () => {
  return (
    <div className='w-full border-b-[3px]  border-[#EDF0EF] bg-[#FAFBFB] md:p-4 p-2 md:h-[100px] h-[40px] flex items-center justify-between'>
          <div className={`p-4 mt-1 flex items-center md:w-[350px]`}>
<div>
          <Settings className="md:h-[24px] h-[12px] w-[12px] md:w-[24px] " />
</div>
<span className="md:text-lg text-[6px] font-semibold text-black py-6">Settings</span>
      </div>
      <div className="flex justify-center gap-1 md:gap-2 px-1 sm:px-4 md:px-6 py-1 md:py-2 w-full">
        {[
          { name: "License", link: "/license" },
          { name: "Terms and conditions", link: "/termsandcondition" },
          { name: "Privacy Policy", link: "/privacypolicy" },
          { name: "Data Usage", link: "/datausage" },
          { name: "FAQs", link: "/faqs" },
          { name: "Policies", link: "#" },
          { name: "Contact us", link: "/contactus" },
        ].map((item, index) => (
          <h1
            key={index}
            className="text-[6px] md:text-[16px] font-medium md:h-[44px] md:w-[140px] bg-[#F3F5F5] rounded-md p-1 sm:p-2 mb-0 flex justify-center items-center text-center sm:w-auto"
          >
            {item.link !== "#" ? (
              <a href={item.link} className="hover:underline text-left">
                {item.name}
              </a>
            ) : (
              item.name
            )}
          </h1>
        ))}
      </div>
    </div>
  );
};


export default Footer;
